import { useSearchParams } from "react-router-dom";
import { useUserContext } from "@hooks/useUserContext";
import { getCurrentLang } from "@utils/getCurrentLang";

export function useCurrentLang(fallbackLang?: string) {
  const [searchParams] = useSearchParams();
  const { user } = useUserContext();

  return getCurrentLang(
    searchParams.get("_storyblok_lang"),
    fallbackLang ?? user?.languagePreference
  );
}
